const CHANNEL_TYPES = Object.freeze({
  AMIO_CHAT: 'amio_chat',
  FACEBOOK_MESSENGER: 'facebook_messenger',
  TELEGRAM: 'telegram',
  WHATSAPP: 'whatsapp',
  EMAIL_DAKTELA: 'email_daktela'
})

const CHANNEL_TYPE_ICON_MAP = Object.freeze({
  amio_chat: 'AmioChatIconColored',
  facebook_messenger: 'MessengerIconColored',
  telegram: 'TelegramIconColored',
  whatsapp: 'WhatsappIconColored',
  email_daktela: 'DaktelaIconColored'
})

// Which existing channels a bot may be deployed to, keyed by bot type (BOT_TYPES in bot.constants.js).
const CHANNEL_TYPES_BY_BOT_TYPE = Object.freeze({
  chat: [CHANNEL_TYPES.AMIO_CHAT, CHANNEL_TYPES.FACEBOOK_MESSENGER, CHANNEL_TYPES.TELEGRAM, CHANNEL_TYPES.WHATSAPP],
  email: [CHANNEL_TYPES.EMAIL_DAKTELA]
})

export { CHANNEL_TYPES, CHANNEL_TYPE_ICON_MAP, CHANNEL_TYPES_BY_BOT_TYPE }
